import React, { useState, useEffect } from 'react';
import { get } from 'aws-amplify/api';

const Dashboard = ({ user }) => {
  const [memberCount, setMemberCount] = useState(0);
  const [recentMembers, setRecentMembers] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await get({
        apiName: 'navy-football-api',
        path: '/members'
      }).response;
      
      const members = await response.body.json();
      setMemberCount(members.length);
      setRecentMembers(members.slice(-5));
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-navy-primary to-navy-secondary text-white p-8 rounded-lg">
        <h1 className="text-3xl font-bold mb-2">Welcome to Navy Football Brotherhood</h1>
        <p className="text-lg opacity-90">Stay connected with your fellow Navy Football alumni</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold text-navy-primary dark:text-gold-primary mb-2">
            Total Members
          </h3>
          <p className="text-3xl font-bold text-gold-primary">{memberCount}</p>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold text-navy-primary dark:text-gold-primary mb-2">
            Your Class Year
          </h3>
          <p className="text-3xl font-bold text-gold-primary">
            {user?.attributes?.custom?.class_year || 'N/A'}
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold text-navy-primary dark:text-gold-primary mb-2">
            Quick Actions
          </h3>
          <div className="space-y-2">
            <button className="w-full bg-navy-primary text-white py-2 px-4 rounded hover:bg-navy-secondary transition-colors">
              Update Profile
            </button>
            <button className="w-full bg-gold-primary text-navy-primary py-2 px-4 rounded hover:bg-gold-secondary transition-colors">
              Reserve Seat
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
        <h3 className="text-lg font-semibold text-navy-primary dark:text-gold-primary mb-4">
          Recent Members
        </h3>
        <div className="space-y-2">
          {recentMembers.map((member, index) => (
            <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200 dark:border-gray-700">
              <span>{member.first_name} {member.last_name}</span>
              <span className="text-sm text-gray-500">Class of {member.class_year}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;